/* eslint-disable no-param-reassign */
const generalSlice = (set) => ({
  general: {
    user: null,
    store: null,
    setUser: (user) => {
      set((state) => {
        state.general.user = user;
      });
    },
    setStore: (store) => {
      set((state) => {
        state.general.store = store;
      });
    },
  },
});

export default generalSlice;
